import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as signalR from '@microsoft/signalr';
import { DataService } from './data.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private hubConnection!: signalR.HubConnection;
  private apiBaseUrl = environment.apiMensajeUrl;
  private receivedMessageSubject = new BehaviorSubject<any | null>(null);
  public receivedMessage$ = this.receivedMessageSubject.asObservable();
  private unreadMessagesSubject = new BehaviorSubject<number>(0);
  public unreadMessages$ = this.unreadMessagesSubject.asObservable();

  constructor(private dataService: DataService) {}

  // Inicia la conexión SignalR
  startConnection(token: any): void {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${this.apiBaseUrl}mensajeHub`, {
        accessTokenFactory: () => token,
      })
      .withAutomaticReconnect([0, 2000, 5000, 10000])
      .build();
  
    this.hubConnection
      .start()
      .then(() => {
        console.log('Conexión SignalR iniciada');
        this.listenForNotifications();
      })
      .catch(err => console.error('Error al conectar SignalR: ', err));
  
    // Manejo de reconexión
    this.hubConnection.onreconnecting(() => {
      console.warn('Reconectando SignalR...');
    });
  
    this.hubConnection.onreconnected(connectionId => {
      console.log('Reconexión exitosa, Connection ID:', connectionId);
      this.loadUnreadMessages();
    });
  
    this.hubConnection.onclose(err => {
      console.error('Conexión SignalR cerrada:', err);
      setTimeout(() => this.startConnection(token), 5000);
    });
  }
  
  private listenForNotifications(): void {
    this.hubConnection.on('NewMessageNotification', () => {
      this.incrementUnreadMessages();
    });

    this.hubConnection.on('MensajeRecibido', (mensaje: any) => {
      console.log('Mensaje recibido:', mensaje);
      this.handleReceivedMessage(mensaje);
    });
  }
  
  private handleReceivedMessage(mensaje: any): void {
    this.receivedMessageSubject.next(mensaje);
  }

  loadUnreadMessages(): void {
    this.dataService.getData('mensajes/no-leidos', this.apiBaseUrl).subscribe({
      next: count => {
        this.unreadMessagesSubject.next(count);
      },
      error: err => console.error('Error al cargar mensajes no leídos:', err)
    });
  }

  public sendMessage(mensaje: any): void {
    this.hubConnection.invoke('SendMessage', mensaje)
      .then(() => console.log('Mensaje enviado:', mensaje))
      .catch(err => console.error('Error al enviar mensaje:', err));
  }

  private incrementUnreadMessages(): void {
    const currentCount = this.unreadMessagesSubject.value;
    this.unreadMessagesSubject.next(currentCount + 1);
  }
}
